import { render, staticRenderFns } from "./DiscountIcon.vue?vue&type=template&id=4f3148d2&"
import script from "./DiscountIcon.vue?vue&type=script&lang=ts&"
export * from "./DiscountIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports